export default __webpack_public_path__ + "static/media/call-end.4971ab6c.svg";